module.exports = __webpack_public_path__ + "img/banner-list-3.21120f76.svg";